import { ErrorCode } from '@dealstack/shared/lib/common/errors';

export class BackendCodedError extends Error {
	constructor(
		readonly code: number | undefined,
		message: string
	) {
		super(message);
		this.name = 'BackendCodedError';
	}
}

interface JsonBearingResponse {
	json(): Promise<unknown>;
}

export const backendCodedErrorFrom = async (
	response: JsonBearingResponse
): Promise<BackendCodedError> => {
	try {
		const body = (await response.json()) as { error?: ErrorCode };
		return new BackendCodedError(body?.error?.code, body?.error?.message ?? 'Request failed');
	} catch {
		return new BackendCodedError(undefined, 'Request failed');
	}
};

const numericCode = (value: unknown): number | undefined => {
	if (typeof value !== 'object' || value === null || !('code' in value)) {
		return undefined;
	}
	if (typeof value.code !== 'number') {
		return undefined;
	}
	return value.code;
};

export const getBackendErrorCode = (error: unknown): number | undefined => {
	const direct = numericCode(error);
	if (direct !== undefined) {
		return direct;
	}
	if (typeof error !== 'object' || error === null || !('error' in error)) {
		return undefined;
	}
	return numericCode(error.error);
};
